import { render, staticRenderFns } from "./Toolhead.vue?vue&type=template&id=006f36d0&scoped=true&"
import script from "./Toolhead.vue?vue&type=script&lang=ts&"
export * from "./Toolhead.vue?vue&type=script&lang=ts&"
import style0 from "./Toolhead.vue?vue&type=style&index=0&id=006f36d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f36d0",
  null
  
)

export default component.exports